import SwiperCore, { Keyboard, Navigation, Pagination, Zoom } from 'swiper';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/zoom/zoom.min.css';
import 'swiper/swiper.scss';

SwiperCore.use([Navigation, Pagination, Keyboard, Zoom]);

export { Swiper as SwiperClass } from 'swiper';
export * from 'swiper/react';
